// Configuração das variáveis de ambiente
export const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3333',
  APP_URL: process.env.REACT_APP_URL || 'http://localhost:3101',
  PORT: process.env.PORT || '3101',
}
